"use client"
import React from "react";
import Image from "next/image";
import {cn} from "@/lib/utils";
import {Separator} from "@/registry/default/ui/separator";
import {useTranslations} from 'next-intl'
import {Button, buttonVariants} from "@/registry/default/ui/button";
import Link from "next/link";

interface IntroPageProps {
    config?: any;
}
export default function IntroPage({config}: IntroPageProps) {
    const t = useTranslations('home.intro')
    return (
        <div className={'bg-[#FFFFFF] text-foreground dark:text-background'}>
            <div className="container px-0 flex mt-12 h-full">
                <div className=" flex w-[50%] items-center justify-center overflow-hidden ">
                    <div className=" h-full w-full">
                            <Image
                              alt={'intro-two'}
                              src={'/home/holp.svg'}
                              width={250}
                              height={150}
                              className={cn(
                                "w-full object-cover transition-all"
                              )}
                            />
                    </div>
                </div>
                <div className={'flex w-[50%] items-center justify-center'}>
                    <div className=" flex flex-col w-full gap-6 px-10">
                        <h6 className="text-base md:text-xl  text-blue-600 font-medium flex w-full h-full  ">
                            我们的愿景
                        </h6>
                        <h2 className="text-3xl md:text-3xl font-medium   w-full h-full ">
                            让 AI 智能组织大幅提升社会效率
                        </h2>
                        <h2 className="text-md w-full h-full  ">
                            在拨业务日常调整频繁，一个新业务通常要经历十几次调整后才能趋于稳定，能够快捷的调整话术非常关键。我们提供 AI 电话员工话术维护功能，让你轻松应对业务调整，快速响应，实时变更，无培训与纠错成本；
                        </h2>
                    </div>
                </div>

            </div>
        </div>
    )
}
